import i18n from "@/i18n";
import { BuefyTypes } from "@/utils/BuefyUtils";
import { ToastProgrammatic as Toast } from "buefy";
import {
  RateLimitNotifier,
  resolveRateLimitMessage,
} from "@/composable/http/rateLimitHandler";

const TOAST_POSITION = "is-top";
const TOAST_DURATION_MS = 8000;
const ANTI_SPAM_THROTTLE_MS = 1500;

/**
 * Implémentation Buefy de {@link RateLimitNotifier} : affiche un toast
 * rouge persistant ( 8s ) sur réception d'un HTTP 429 . Throttle anti-
 * spam ( 1.5s ) pour éviter une rafale de toasts si l'utilisateur
 * déclenche plusieurs requêtes simultanées toutes rejetées .
 *
 * <p>Le throttle est porté ICI ( instance Buefy ) et non dans le helper
 * pur , parce que c'est une politique d'affichage UI ; le helper reste
 * 100% logique , testable sans timer .
 */
export class RateLimitToastNotifier implements RateLimitNotifier {
  static INSTANCE: RateLimitToastNotifier = new RateLimitToastNotifier();

  #lastEmitTimestamp = 0;

  notifyRateLimited(retryAfterSec: number | null): void {
    const now = Date.now();
    if (now - this.#lastEmitTimestamp < ANTI_SPAM_THROTTLE_MS) return;
    this.#lastEmitTimestamp = now;

    const { key, params } = resolveRateLimitMessage(retryAfterSec);
    new Toast().open({
      message: i18n.global.t(key, params),
      type: BuefyTypes.DANGER,
      duration: TOAST_DURATION_MS,
      position: TOAST_POSITION,
    });
  }
}
